import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@arcadeai/design-system/components/ui/atoms/popover";
import { Loader2, Trash2 } from "lucide-react";
import { useState } from "react";
import { useDeleteProjectInvitation } from "../../api/hooks";

export const DeleteInvitationButton = ({
  invitationId,
  inviteeEmail,
}: {
  invitationId: string;
  inviteeEmail: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mutate: deleteInvitation, isPending } = useDeleteProjectInvitation();

  const handleDelete = () => {
    deleteInvitation({ invitationId });
    setIsOpen(false);
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger
        render={
          <Button
            className="text-destructive/70 hover:text-destructive"
            disabled={isPending}
            size="icon"
            variant="ghost"
          />
        }
      >
        {isPending ? (
          <Loader2 className="size-4 animate-spin" />
        ) : (
          <Trash2 className="size-4" />
        )}
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <div className="grid gap-4">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">Delete Invitation</h4>
            <p className="text-muted-foreground text-sm">
              Are you sure you want to delete the invitation for {inviteeEmail}?
              This action cannot be undone.
            </p>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              onClick={() => setIsOpen(false)}
              size="sm"
              variant="outline"
            >
              Cancel
            </Button>
            <Button
              disabled={isPending}
              onClick={handleDelete}
              size="sm"
              variant="destructive"
            >
              {isPending ? (
                <Loader2 className="size-4 animate-spin" />
              ) : (
                "Delete"
              )}
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
